import {
  createApp
} from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'

function getRem(pwidth, prem) {
  var html = document.getElementsByTagName("html")[0];
  var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
  // var oWidth = 500
  console.log(document.body.clientWidth, document.documentElement.clientWidth)
  if (oWidth > 500) oWidth = 500;
  html.style.fontSize = oWidth / pwidth * prem + "px";
}
getRem(750, 100)
// window.onload = function() {
//   getRem(750, 100)
// };
window.onresize = function() {
  getRem(750, 100)
};
createApp(App).use(router).use(ElementPlus).mount('#app')
